import React from 'react';
import clsx from 'clsx';
import { Theme } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ spacing }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    marginLeft: spacing(2),
    border: `1px solid ${colorPalette.grey.main}`,
    borderRadius: 5,
    overflow: 'hidden',
  },
}));

interface Props {
  className?: string;
  children: React.ReactNode;
}

export function MasterViewBody({ children, className, ...props }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, className)} {...props}>
      {children}
    </div>
  );
}
